import { REQUEST_REPORTS_LIST, RESPONSE_REPORTS_LIST, REQUEST_REPORTS_LIST_FAILURE } from "../actions/reportsListActions";

import {
  RESPONSE_CREATE_CUSTOM_REPORT,
  RESPONSE_DELETE_CUSTOM_REPORT,
  RESPONSE_UPDATE_CUSTOM_REPORT_TITLE,
  RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_DELETE_FIELD_CUSTOM_REPORT,
  RESPONSE_ADD_FIELD_CUSTOM_REPORT,
  RESPONSE_UPDATE_FIELD_CUSTOM_REPORT,
  RESPONSE_SHIFT_FIELD_CUSTOM_REPORT,
  RESPONSE_UPDATE_AXIS_CUSTOM_REPORT,
} from "../actions/customReportActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  data: [],
  errors: [],
};

const reportsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REPORTS_LIST: {
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    }
    case RESPONSE_REPORTS_LIST: {
      return Object.assign({}, state, {
        dataState: states.READY,
        data: action.data,
      });
    }
    case REQUEST_REPORTS_LIST_FAILURE: {
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    }
    case RESPONSE_CREATE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.concat(action.data),
      });
    }

    case RESPONSE_DELETE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }

    case RESPONSE_UPDATE_CUSTOM_REPORT_TITLE: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.data.id) {
            x.title = action.data.title;
          }

          return x;
        }),
      });
    }

    case RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.dashboards = x.dashboards
              .filter((dashboard) => {
                return dashboard.id !== action.id;
              })
              .map((dashboard) => {
                dashboard.number = action.data[dashboard.id];

                return dashboard;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    case RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.dashboards = x.dashboards
              .map((dashboard) => {
                dashboard.number = action.data.dashboardNumbers[dashboard.id];

                return dashboard;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    case RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.dashboards = x.dashboards
              .map((dashboard) => {
                if (dashboard.id === action.data.id) {
                  dashboard.title = action.data.title;
                }

                return dashboard;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    case RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.dashboards = x.dashboards.concat(action.data);
          }

          return x;
        }),
      });
    }

    case RESPONSE_DELETE_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.fields = x.fields
              .filter((field) => {
                return field.id !== action.id;
              })
              .map((field) => {
                field.number = action.data[field.id];

                return field;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    case RESPONSE_ADD_FIELD_CUSTOM_REPORT: {

      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.fields = x.fields.concat(action.data);
          }

          return x;
        }),
      });
    }

    case RESPONSE_UPDATE_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.fields = x.fields
              .map((field) => {
                if (field.id === action.data.id) {
                  field.dashboard.title = action.data.title;
                  field.excelColumnWidth = action.data.excelColumnWidth;
                  field.cssColumnWidth = action.data.cssColumnWidth;
                }

                return field;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    case RESPONSE_UPDATE_AXIS_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.fields = x.fields
              .map((field) => {
                if (field.chartAxis.id === action.data.id) {
                  field.chartAxis.color = action.data.color;
                  field.chartAxis.valueOn = action.data.valueOn;
                  field.chartAxis.useSecondaryAxis = action.data.useSecondaryAxis;
                  field.chartAxis.type = action.data.type;
                }

                return field;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    case RESPONSE_SHIFT_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        data: state.data.map((x) => {
          if (x.id === action.reportId) {
            x.fields = x.fields
              .map((field) => {
                field.number = action.data.fieldNumbers[field.id];

                return field;
              })
              .sort(sortByNumber);
          }

          return x;
        }),
      });
    }

    default:
      return state;
  }
};

function sortByNumber(a, b) {
  return a.number - b.number;
}

export default reportsListReducer;
